export default {"src":"/_next/static/media/RetailStructureIconRed.983053a0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};